module.exports = __webpack_public_path__ + "img/Coralie-logo1.f7a56784.png";